import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';

// Loading spinner for page content (not full screen - sidebar stays visible)
function PageLoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="animate-spin rounded-full h-10 w-10 border-2 border-primary border-t-transparent"></div>
    </div>
  );
}

/**
 * Persistent layout component that wraps all routes.
 * The sidebar and header remain mounted during navigation.
 * Only the page content (Outlet) re-renders with Suspense.
 */
export function AppLayout() {
  return (
    <AppShell>
      <Suspense fallback={<PageLoadingSpinner />}>
        <Outlet />
      </Suspense>
    </AppShell>
  );
}














